import React from 'react'
import DefaultHeading from '../../../../../components/heading/DefaultHeading';
import { labelMappings } from '../../../utils/utils';
import { Button, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useCouponAlert } from '../../../context/CouponAlert';
import { getFormattedOverAndAboveBody } from './service';

function OverAndAboveBody(props: any) {
    const { body ,setShowOverAndAboveBody} = props;
    const formattedRequestBody = getFormattedOverAndAboveBody(body);
    
    const { showAlert } = useCouponAlert()


    const handleCopy = async()=>{
        try {
            await navigator.clipboard.writeText(JSON.stringify(formattedRequestBody));
            showAlert("Text Copied","success");
        } catch (error) {
            console.error('Unable to copy text to clipboard', error);
        }
    }
    
    return (
        <div className='over-and-above-body-wrapper'>
            <div className="over-and-above-body-header-wrapper">
                <DefaultHeading heading={labelMappings['OVER_AND_ABOVE_BODY_HEADER_TEXT']}>
                    <Button variant='contained' className='over-and-above-body-header-close-btn' onClick={() => setShowOverAndAboveBody((pre: { open: boolean, body: Record<string, any> }) => ({ ...pre, open: false }))}>
                        Close
                    </Button>
                </DefaultHeading>
            </div>
            <div className="over-and-above-body-content-wrapper">
                <div className="over-and-above-body-content-header-wrapper">
                    <p>
                        {labelMappings["OVER_AND_ABOVE_BODY_CONTENT_HEADER_TEXT"]}
                    </p>
                </div>
                <div className="over-and-above-body-content-body-wrapper">
                    <pre>{JSON.stringify(formattedRequestBody, null, 4)}</pre>
                    <div className='over-and-above-body-copy-btn-wrapper'>
                        <IconButton className='over-and-above-body-copy-btn' aria-label="copy" size="large" onClick={handleCopy}>
                            <ContentCopyIcon />
                        </IconButton>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OverAndAboveBody